require('./cardStatementsContent.scss');

// @ vendor
const PropTypes = require('prop-types');
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { EmptyState } = require('commonsComponents/emptyState');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const CardStatementsTable = require('components/cards/cardStatements/cardStatementsTable/cardStatementsTable');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
// @ constants
const {
    CARD_STATEMENT_MONTHLY_EXTRACT,
    CARD_STATEMENT_SPECIAL_PURCHASE
} = require('constants/index');

class CardStatementsContent extends React.Component {
    constructor(props){
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildTable = this.buildTable.bind(this);
    }

    buildTable(statementType) {
        const {
            cardId,
            immScreen,
            immStatements,
        } = this.props;

        let immStatementsByOrder;
        let content;

        switch (statementType) {
            case CARD_STATEMENT_MONTHLY_EXTRACT:
                immStatementsByOrder = immStatements.getIn(['monthlyExtracts', 'byOrder']);
                break;
            case CARD_STATEMENT_SPECIAL_PURCHASE:
                immStatementsByOrder = immStatements.getIn(['specialPurchases', 'byOrder']);
                break;
            default:
                immStatementsByOrder = immStatements.get('byOrder');
                break;
        }

        if (immStatementsByOrder.size > 0) {
            content = (
                <CardStatementsTable
                    cardId={cardId}
                    immScreen={immScreen}
                    immStatements={immStatements}
                    immStatementsByOrder={immStatementsByOrder}
                />
            );
        } else {
            content = (
                <EmptyState
                    iconType="search-banking"
                    primaryText={formatText('cardStatement-noResults')}
                />
            );
        }

        return content;
    }

    buildTabs() {
        const { cardId } = this.props;
        const specialPurchaseTab = (
            <section className="card-statements-content__special-purchases-tab">
                <OKLink
                    extraClass="pull-right"
                    modifier="complementary"
                    to={`/myprofile/cards/${cardId}/deferred-purchases`}
                >
                    <FormattedText value="cardStatement-viewDeferredPurchases" />
                </OKLink>
                {this.buildTable(CARD_STATEMENT_SPECIAL_PURCHASE)}
            </section>
        );

        const tabs = [{
            label: formatText('cardStatement-monthlyExtracts'),
            content: this.buildTable(CARD_STATEMENT_MONTHLY_EXTRACT)
        },
        {
            label: formatText('cardStatement-specialPurchases'),
            content: specialPurchaseTab
        }];

        return (<TabbedBox tabs={tabs} left={true} />);
    }

    buildShowMoreSection() {
        const { cardId, requestCardMoreStatements } = this.props;
        return (
            <footer className="text-right">
                <OKLink modifier="complementary" onClick={() => requestCardMoreStatements(cardId)}>
                    <FormattedText value="transfersLanding-completeAgenda" />
                </OKLink>
            </footer>
        );
    }

    render() {
        const { immStatements } = this.props;
        let content;

        if (immStatements.get('error')) {
            content = (
                <EmptyState
                    primaryText={formatText('cardStatement-noConnection')}
                    iconType="nointernet-banking"
                />
            );
        } else {
            const headerTitle = <FormattedText value="cards-statements" format="firstUppercase" />;
            const tabs = this.buildTabs();
            let showMoreSection;

            if (immStatements.get('isFetchingMore')) {
                showMoreSection= <LoadingSection />;
            } else if (immStatements.get('moreData')) {
                showMoreSection = this.buildShowMoreSection();
            }

            content = (
                <div className="card-statements-content">
                    <div className="card-statements-content__title">
                        <OKBoxTitle value={headerTitle} />
                    </div>
                    {tabs}
                    {showMoreSection}
                </div>
            );
        }

        return content;
    }
}

CardStatementsContent.propTypes = {
    cardId: PropTypes.string.isRequired,
    immScreen: PropTypes.object.isRequired,
    immStatements: PropTypes.object.isRequired,
    requestCardMoreStatements: PropTypes.func.isRequired,
}

module.exports = CardStatementsContent;